export default "__VITE_ASSET__CEedP5jl__"